import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MarketingPreferencesFormValue } from '@checkout/util-models';
import { CmsBrandPrivacyPolicyPipe } from '@domgen/dgx-fe-cms';
import {
  InterpolatePipe,
  TestHookDirective,
} from '@domgen/dgx-fe-components/general';
import { CheckboxComponent } from '@domgen/dgx-fe-forms/checkbox';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormFieldsetComponent,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import { RadioButtonComponent } from '@domgen/dgx-fe-forms/radio';
import { FormSubmitDirective } from '@domgen/dgx-fe-forms/shared';
import {
  GAClickDirective,
  GAContainerDirective,
  GAFormSubmitDirective,
} from '@domgen/dgx-fe-ga';
import { TranslatePipe } from '@domgen/dgx-fe-i18n';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';
import { MarketingPreferencesTestHooks } from '../../models/test/marketing-preferences-test-hooks.enum';
import { provideMarketingPreferencesI18n } from '../../providers/marketing-preferences-i18n.provider';
import { MarketingPreferencesFormBuilder } from '../../services/marketing-preferences-form-builder/marketing-preferences-form-builder.service';
import { MarketingPreferencesFormComponentService } from '../../services/marketing-preferences-form-component/marketing-preferences-form-component.service';

@Component({
  selector: 'checkout-marketing-preferences-form',
  standalone: true,
  imports: [
    AsyncPipe,
    CheckboxComponent,
    CmsBrandPrivacyPolicyPipe,
    FormFieldComponent,
    FormFieldDirective,
    FormFieldsetComponent,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAClickDirective,
    GAContainerDirective,
    GAFormSubmitDirective,
    InterpolatePipe,
    NgIf,
    QMSanitiseDirective,
    RadioButtonComponent,
    ReactiveFormsModule,
    TestHookDirective,
    TranslatePipe,
  ],
  providers: [
    MarketingPreferencesFormBuilder,
    MarketingPreferencesFormComponentService,
    provideMarketingPreferencesI18n(),
  ],
  templateUrl: './marketing-preferences-form.component.html',
  styleUrls: ['./marketing-preferences-form.component.scss'],
})
export class MarketingPreferencesFormComponent implements OnInit {
  @Output() submitted = new EventEmitter<MarketingPreferencesFormValue>();

  testHooks = MarketingPreferencesTestHooks;

  constructor(readonly cs: MarketingPreferencesFormComponentService) {}

  ngOnInit(): void {
    this.cs.buildForm();
  }

  onFormSubmit(formValue: MarketingPreferencesFormValue): void {
    this.submitted.emit(formValue);
  }
}
